import { Judge } from '~/apis/ssf';
import { match } from 'ts-pattern';
import { Badge } from '~/components/Badge/Badge';

interface Props {
  referee: Pick<Judge, 'status'>;
}

export function RefereeStatusBadge({ referee }: Props) {
  return match(referee)
    .with({ status: 'active' }, () => <Badge variant="success" label="Aktiv" />)
    .with({ status: 'warned' }, () => <Badge variant="warning" label="Varnad" />)
    .with({ status: 'suspended' }, () => <Badge variant="danger" label="Avstängd" />)
    .with({ status: 'unknown' }, () => <Badge variant="default" label="Okänd" />)
    .otherwise(() => referee.status);
}
